/**
 * Col Component - Column within a 12-column Row
 * Use span prop to specify how many columns to occupy (1-12)
 */

import React from 'react';
import styles from './Col.module.css';

const Col = ({
  children,
  className = '',
  span = 12, // 1-12, how many columns to span
  sm, // Optional: span on small screens (mobile)
  md, // Optional: span on medium screens (tablet)
  lg, // Optional: span on large screens (desktop)
  offset = 0, // Optional: offset columns from the left (0-11)
  padding = 'none', // 'none', 'small', 'medium', 'large'
  align = 'top', // 'top', 'center', 'bottom' - vertical alignment of content
  style = {}
}) => {
  const colClasses = [
    styles.col,
    styles[`span-${span}`],
    sm && styles[`sm-${sm}`],
    md && styles[`md-${md}`],
    lg && styles[`lg-${lg}`],
    offset > 0 && styles[`offset-${offset}`],
    styles[`padding-${padding}`],
    styles[`align-${align}`],
    className
  ].filter(Boolean).join(' ');

  return (
    <div className={colClasses} style={style}>
      {children}
    </div>
  );
};

export default Col;
